<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="33"
    height="32"
    viewBox="0 0 33 32"
    fill="none"
  >
    <rect width="33" height="32" fill="#1E1E1E" />
    <g id="Golden Box">
      <path
        d="M-1625 -821C-1625 -822.105 -1624.1 -823 -1623 -823H4363C4364.1 -823 4365 -822.105 4365 -821V1613C4365 1614.1 4364.1 1615 4363 1615H-1623C-1624.1 1615 -1625 1614.1 -1625 1613V-821Z"
        fill="#444444"
      />
      <path
        d="M-1623 -823V-822H4363V-823V-824H-1623V-823ZM4365 -821H4364V1613H4365H4366V-821H4365ZM4363 1615V1614H-1623V1615V1616H4363V1615ZM-1625 1613H-1624V-821H-1625H-1626V1613H-1625ZM-1623 1615V1614C-1623.55 1614 -1624 1613.55 -1624 1613H-1625H-1626C-1626 1614.66 -1624.66 1616 -1623 1616V1615ZM4365 1613H4364C4364 1613.55 4363.55 1614 4363 1614V1615V1616C4364.66 1616 4366 1614.66 4366 1613H4365ZM4363 -823V-822C4363.55 -822 4364 -821.552 4364 -821H4365H4366C4366 -822.657 4364.66 -824 4363 -824V-823ZM-1623 -823V-824C-1624.66 -824 -1626 -822.657 -1626 -821H-1625H-1624C-1624 -821.552 -1623.55 -822 -1623 -822V-823Z"
        fill="white"
        fill-opacity="0.1"
      />
      <g id="Whatsapp">
        <g id="Idea" clip-path="url(#clip0_1_6)">
          <rect
            width="375"
            height="812"
            transform="translate(-55 -723)"
            fill="white"
          />
          <path
            id="GL+ vector"
            d="M545.773 -695.97C490.557 -716.938 241.404 -797.338 239.006 -725.066C236.009 -634.726 695.301 -245.986 473.595 -296.173C247.514 -347.351 -262.389 -855.01 -76.5626 -530.247C109.264 -205.485 385.958 458.194 71.5766 290.515C-242.805 122.836 -354.412 -207.924 -517.906 23.2457C-681.4 254.415 -819.681 292.523 -855.046 -157.716C-890.41 -607.955 -1092.24 -851.829 -1325 -848.352"
            stroke="url(#paint0_linear_1_6)"
            stroke-opacity="0.4"
            stroke-width="150"
            stroke-linecap="round"
          />
          <g id="Container">
            <rect
              width="375"
              height="468"
              transform="translate(-55 -379)"
              fill="white"
            />
            <g id="Share Container">
              <path
                d="M-55 -51C-55 -57.6274 -49.6274 -63 -43 -63H308C314.627 -63 320 -57.6274 320 -51V89H-55V-51Z"
                fill="#F8FAFC"
              />
              <g id="Share Options Container">
                <g id="62">
                  <rect
                    x="-34.5"
                    y="-11.5"
                    width="102.667"
                    height="80"
                    rx="7.5"
                    fill="white"
                  />
                  <rect
                    x="-34.5"
                    y="-11.5"
                    width="102.667"
                    height="80"
                    rx="7.5"
                    stroke="#CBD5E1"
                  />
                  <g id="Digital_Glyph_Green 2" clip-path="url(#clip1_1_6)">
                    <path
                      id="Vector"
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M28.1709 4.64667C25.1632 1.65171 21.1629 0.00151951 16.9007 0C8.11803 0 0.970248 7.10754 0.967192 15.844C0.965664 18.6368 1.69985 21.3628 3.09411 23.7652L0.833496 31.9767L9.28004 29.7733C11.6071 31.0361 14.2275 31.7009 16.8939 31.7017H16.9007C25.6819 31.7017 32.8305 24.5933 32.8335 15.8569C32.835 11.6228 31.1795 7.6424 28.1709 4.64743V4.64667ZM16.9007 29.0258H16.8954C14.5194 29.0251 12.1885 28.3898 10.1548 27.1902L9.6712 26.9046L4.65874 28.2121L5.99647 23.3519L5.6817 22.8535C4.3562 20.7566 3.65563 18.3329 3.65716 15.8448C3.66022 8.58374 9.60091 2.67586 16.9061 2.67586C20.4433 2.67738 23.7682 4.04875 26.2686 6.53848C28.7691 9.02745 30.1451 12.337 30.1435 15.8554C30.1404 23.1172 24.1998 29.0251 16.9007 29.0251V29.0258ZM24.1646 19.1626C23.7666 18.9643 21.8093 18.007 21.4441 17.8748C21.0789 17.7426 20.8139 17.6766 20.5487 18.0731C20.2836 18.4697 19.5204 19.3617 19.2882 19.6253C19.0559 19.8897 18.8236 19.9224 18.4256 19.724C18.0276 19.5257 16.7449 19.1079 15.2238 17.7593C14.0404 16.7093 13.2412 15.4132 13.0091 15.0166C12.7768 14.62 12.9846 14.4057 13.1832 14.209C13.3619 14.0312 13.5812 13.7463 13.7806 13.5153C13.9801 13.2843 14.0458 13.1188 14.1787 12.8551C14.3116 12.5907 14.2451 12.3598 14.1459 12.1614C14.0465 11.9631 13.2505 10.0143 12.9181 9.22192C12.5949 8.45002 12.2665 8.55487 12.0227 8.54196C11.7905 8.53055 11.5254 8.52828 11.2595 8.52828C10.9937 8.52828 10.5627 8.62705 10.1976 9.02365C9.83243 9.4202 8.80408 10.3783 8.80408 12.3263C8.80408 14.2743 10.2305 16.1578 10.4299 16.4222C10.6292 16.6866 13.2374 20.6852 17.2307 22.4007C18.1804 22.8087 18.9222 23.0526 19.5005 23.2349C20.454 23.5365 21.3219 23.494 22.0079 23.3922C22.7727 23.2782 24.3633 22.4341 24.6948 21.5095C25.0264 20.5848 25.0264 19.7916 24.9271 19.6268C24.8278 19.4619 24.5619 19.3624 24.1639 19.1641L24.1646 19.1626Z"
                      fill="#25D366"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_1_6"
        x1="469.735"
        y1="-844.708"
        x2="-691.388"
        y2="444.609"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#78A7FF" />
        <stop offset="0.414052" stop-color="#6C53FF" />
        <stop offset="0.734355" stop-color="#1A2330" />
      </linearGradient>
      <clipPath id="clip0_1_6">
        <rect
          width="375"
          height="812"
          fill="white"
          transform="translate(-55 -723)"
        />
      </clipPath>
      <clipPath id="clip1_1_6">
        <rect
          width="32"
          height="32"
          fill="white"
          transform="translate(0.833496)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
